import { useEffect, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang, copy } from "@/i18n";

export default function IntroOverlay() {
  const { lang } = useLang();
  const c = copy[lang].hero;
  const [rect, setRect] = useState(null);
  const [fadeEnd, setFadeEnd] = useState(500);
  const { scrollY } = useScroll();
  const opacity = useTransform(scrollY, [0, fadeEnd], [1, 0]);

  useEffect(() => {
    const measure = () => {
      const el = document.querySelector('[data-testid="hero-logo"]');
      if (!el) return;
      const r = el.getBoundingClientRect();
      setRect({
        top: r.top + window.scrollY,
        left: r.left,
        width: r.width,
        height: r.height,
      });
      setFadeEnd(Math.round(window.innerHeight * 0.15));
    };
    measure();
    const timers = [setTimeout(measure, 800), setTimeout(measure, 3600)];
    window.addEventListener("resize", measure);
    window.addEventListener("load", measure);
    return () => {
      timers.forEach(clearTimeout);
      window.removeEventListener("resize", measure);
      window.removeEventListener("load", measure);
    };
  }, []);

  return (
    <motion.div
      data-testid="intro-overlay"
      style={{ opacity }}
      className="absolute inset-x-0 top-0 h-screen z-30 pointer-events-none"
    >
      <div className="absolute inset-0" style={{ background: "#050505" }} />
      {rect && (
        <div
          className="absolute"
          style={{
            top: rect.top,
            left: rect.left,
            width: rect.width,
            height: rect.height,
          }}
        >
          <motion.img
            data-testid="intro-logo"
            src="/fmf-logo-white.png"
            alt="FMF"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.6, delay: 0.3 }}
            className="w-full h-full object-contain"
          />
          <motion.p
            data-testid="intro-phrase"
            initial={{ opacity: 0, x: "-50%", y: 12 }}
            animate={{ opacity: 1, x: "-50%", y: 0 }}
            transition={{ duration: 2.2, delay: 1.7, ease: [0.16, 1, 0.3, 1] }}
            className="absolute left-1/2 w-full md:w-max px-6 text-center font-serif-fmf font-light text-xl md:text-3xl leading-snug fmf-gold-text md:whitespace-nowrap"
            style={{ top: rect.height + 48 }}
          >
            {c.intro1} <span className="italic">{c.intro2}</span>
          </motion.p>
        </div>
      )}
    </motion.div>
  );
}
